import styled from "@emotion/styled";
var Label = /*#__PURE__*/ styled("label", {
    target: "e1memdmb0"
})("display:block;position:relative;margin:0.5em 1rem 1rem;font-size:0.875rem;line-height:1.5;color:", function(param) {
    var theme = param.theme;
    return theme.color.error;
}, ";cursor:", function(param) {
    var htmlFor = param.htmlFor;
    return htmlFor ? "pointer" : "";
}, ";");
export { Label };
